// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-c3f69146]::-webkit-outer-spin-button,\ninput[data-v-c3f69146]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-c3f69146] {\n  -moz-appearance: textfield;\n}\n.state-rows[data-v-c3f69146] {\n  overflow-y: auto;\n}\n.state-search[data-v-c3f69146] .input-group-text,\n.state-search[data-v-c3f69146] .form-control {\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
